module.exports = __webpack_public_path__ + "img/tw.8a194685.svg";